import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './Providers';
import { router } from '@/routes/router';

export default function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
